import { RevOsRenameCopyChange } from 'pricing-pages-ui-components/i18n/CopyChangeComponents';
import { useIsRevenueHubEnabled } from '../../hooks/useIsRevenueHubEnabled';
import { jsx as _jsx } from "react/jsx-runtime";
export function RevOsRename({
  children
}) {
  const isRevOsRenamed = useIsRevenueHubEnabled();
  return /*#__PURE__*/_jsx(RevOsRenameCopyChange, {
    isRevOsRenamed: isRevOsRenamed,
    children: children
  });
}